import { Form as ShadForm } from '~/ComponentsTW/ui/form';
import { Input as ShadInput } from '~/ComponentsTW/ui/input';
import { Label as ShadLabel } from '~/ComponentsTW/ui/label';
import * as React from 'react';

const Form = React.forwardRef(({ className, onSubmit, ...props }, ref) => {
    const id = React.useId();

    return (
        <div className="tw-grid tw-gap-4">
            <ShadForm className={className} onSubmit={onSubmit} ref={ref} {...props} id={id}/>
        </div>
    );
});
Form.displayName = 'Form';

const FormInput = React.forwardRef(({ className, ...props }, ref) => {
    const id = React.useId();

    return (
        <ShadInput className={`${className} tw-mt-[-8px]`} ref={ref} {...props} id={id}/>
    );
});
FormInput.displayName = 'FormInput';

const FormLabel = React.forwardRef(({ className, ...props }, ref) => {
    const id = React.useId();

    return (
        <ShadLabel className={`tw-ml-2 tw-text-lg tw-mb-0 ${className}`} ref={ref} {...props} id={id}/>
    );
});
FormLabel.displayName = 'FormLabel';

export {
    Form,
    FormInput,
    FormLabel
    // WmFormControl,
    // WmFormDescription,
    // WmFormMessage,
    // WmFormField
};
